import FileUpload from '@nkr/components/file-upload';
import { useState } from 'react';
import { Button, Panel, Radio } from 'react-bootstrap';
import { DropEvent, FileRejection } from 'react-dropzone';

interface IProps {
    onUploadFile: (hasColumnHeaders: boolean, file: File) => void
}

const UploadFile = (props: IProps) => {
    const [hasColumnHeaders, setHasColumnHeaders] = useState(true);
    const [files, setFiles] = useState<File[]>([]);

    const handleFileDropped = (acceptedFiles: File[], fileRejections: FileRejection[], event: DropEvent) => {
        setFiles(acceptedFiles);
    };

    const handleRemoveFile = () => {
        setFiles([]);
    };

    const handleUploadFile = () => {
        props.onUploadFile(hasColumnHeaders, files[0]);
    };

    return (
        <Panel>
            <Panel.Heading>Step 1: Upload File</Panel.Heading>
            <Panel.Body>
                <div>Please upload your CSV file...</div>

                <FileUpload
                    label='Click here to select your CSV file or drag and drop the CSV file here...'
                    files={files}
                    onFileDropped={handleFileDropped}
                    onRemoveFile={handleRemoveFile}
                    singleUploadOnly={false}
                />

                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: 5 }}>
                    <div style={{ marginRight: 10 }}>File has column Headers?</div>
                    <div>
                        <Radio inline name='hasColumnHeaders' checked={hasColumnHeaders} onChange={() => setHasColumnHeaders(true)}>Yes</Radio>
                        <Radio inline name='hasColumnHeaders' checked={!hasColumnHeaders} onChange={() => setHasColumnHeaders(false)}>No</Radio>
                    </div>
                </div>
            </Panel.Body>
            <Panel.Footer className='text-right'>
                <Button bsStyle='primary' disabled={files.length == 0} onClick={handleUploadFile}>Upload File</Button>
            </Panel.Footer>
        </Panel>
    )
}

export default UploadFile;